// extracted by mini-css-extract-plugin
export default {"intelligence-highlight":"components-hotel-channel-pricing-tables-cells-pms-table-prices-pms-table-pricing-row-cell-content-module__intelligence-highlight"};